const MOBILE = 'mobile';
const DESKTOP = 'desktop';

const breakpoints = {};
breakpoints[MOBILE] = '750px';
breakpoints[DESKTOP] = '1440px';

/**
 * CommonJS экспорт тут необходим для прокидывания брейкпоинтов в precss чтоб
 * они были потом доступны в css.
 */
module.exports = {
  MOBILE,
  DESKTOP,
  breakpoints,
};
